module.exports = __webpack_public_path__ + "static/Lora-SemiBoldItalic-c4d0098ab3fd2e0968cb946a99c92071.ttf";